import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'
import { useContent } from 'features/unifiedFlow/contentPage/hooks'

import { getCampaignDetail } from '../api'
import { importKeys } from '../queryKeys'

const useGetCampaignDetailQuery = ({
  integration,
  campaignId,
}: {
  integration: string
  campaignId: string | null
}) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const { content } = useContent()

  const projectId =
    content?.elements[0]?.optimization_settings?.configuration?.project_id ?? ''

  return useQuery(
    importKeys.campaignDetail({
      accountId,
      projectId,
      integration,
      campaignId: campaignId ?? '',
    }),
    () =>
      getCampaignDetail({
        accountId,
        projectId,
        integration,
        brazeCampaignId: campaignId!,
      }),
    {
      enabled: !!campaignId && !!projectId,
    }
  )
}

export default useGetCampaignDetailQuery
